<template>
  <button
    class="flex flex-row items-center gap-xs self-end px-sm"
    v-on:click="$emit('click')"
  >
    <FontAwesomeIcon
      class="text-avtalat-teal"
      v-if="variant === 'left'"
      icon="fa-regular fa-arrow-left"
      size="sm"
    />
    <span class="text-avtalat-teal underline">{{ text }}</span>
    <FontAwesomeIcon
      class="text-avtalat-teal"
      v-if="variant === 'right'"
      icon="fa-regular fa-arrow-right"
      size="sm"
    />
  </button>
</template>
<script setup lang="ts">
import { library } from "@fortawesome/fontawesome-svg-core";
import { faArrowLeft, faArrowRight } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

export type ArrowButtonProps = {
  text: string;
  variant: "left" | "right";
};
defineProps<ArrowButtonProps>();

library.add(faArrowRight, faArrowLeft);
</script>
